import { render, staticRenderFns } from "./WizardProgressBar.vue?vue&type=template&id=45c72a8c&scoped=true&"
import script from "./WizardProgressBar.vue?vue&type=script&lang=js&"
export * from "./WizardProgressBar.vue?vue&type=script&lang=js&"
import style0 from "./WizardProgressBar.vue?vue&type=style&index=0&id=45c72a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c72a8c",
  null
  
)

export default component.exports